import React from "react"
import EngineIDNavBar from "@components/EngineIDNavBar"
import Banner from "./Banner"
import FAQ from "@components/FAQ"
import CTASignUpLong from "@components/CTASignUpLong"
import Footer from "@components/Footer"
import Wrapper from "@components/Wrapper"
import "./index.scss"
import "@styles/global.scss"

const FAQs = props => {
  return (
    <div>
      <EngineIDNavBar />
      <Banner />
      <div className={"container-fluid"}>
        <div className={"maxWidth"}>
          <section className="container-fluid bg-xl-light-gray">
            <div className="row ml-0 mr-0 mb-5">
              <Wrapper className={"w-100 text-left"} gap="outer">
                <div className="row bg-white justify-content-center p-10">
                  <div className={"col-sm-12 col-md 12 col-lg-12 col-xl-12"} >
                    <FAQ></FAQ>
                  </div>
                </div>
              </Wrapper>
            </div>
          </section>
        </div>
      </div>
      <CTASignUpLong />
      <Footer />
    </div>
  )
}

export default FAQs
